export const consultationRubricPage = {
    consultationRubricPageAskButtonDesktop: {
        rbmail: {
            type: 'click',
            id: '28935932',
        },
    },
    consultationRubricPageAskButtonBottomDesktop: {
        rbmail: {
            type: 'click',
            id: '28935936',
        },
    },
    consultationRubricPageAskButtonTouch: {
        rbmail: {
            type: 'click',
            id: '28935940',
        },
    },
    consultationRubricPageConsultantLinkDesktop: {
        rbmail: {
            type: 'click',
            id: '28935934',
        },
    },
    consultationRubricPageConsultantLinkTouch: {
        rbmail: {
            type: 'click',
            id: '28935942',
        },
    },
    consultationRubricPageAllConsultantsDesktop: {
        rbmail: {
            type: 'click',
            id: '28935933',
        },
    },
    consultationRubricPageAllConsultantsTouch: {
        rbmail: {
            type: 'click',
            id: '28935941',
        },
    },
    consultationRubricPageRubricLinkDesktop: {
        rbmail: {
            type: 'click',
            id: '28935937',
        },
    },
    consultationRubricPageQuestionLinkDesktop: {
        rbmail: {
            type: 'click',
            id: '28663859',
        },
    },
    consultationRubricPageQuestionLinkTouch: {
        rbmail: {
            type: 'click',
            id: '28663859',
        },
    },
} as const;
